module.exports = __webpack_public_path__ + "static/media/plenny.9ddee68b.png";